/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const Pause24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Pause 24">
      <path
        fill="#0E0E0E"
        d="M8 4a2 2 0 1 0-4 0v16a2 2 0 1 0 4 0V4Zm12 0a2 2 0 1 0-4 0v16a2 2 0 1 0 4 0V4Z"
        className="Union"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Pause24,
  md: Pause24,
  lg: Pause24,
  xl: Pause24,
  xxl: Pause24,
  xxxl: Pause24,
};

export const PauseIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'pause-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
